import styled from 'styled-components';
import React from 'react';

import { DIVIDER_COLOR } from '../../styles/constants';

export default styled(({ color, ...rest }) => <div {...rest} />)`
  height: 1px;
  background: ${(p) => p.theme[p.color] || DIVIDER_COLOR};
`;
